export default "__VITE_PUBLIC_ASSET__78b55fff__"